import { operatePicInfo } from 'utils/enum';
import { getUuid } from '@mcfe/tools';

export const NOMAL_WIDTH = 800;
export const NOMAL_HEIGHT = 800;
export const NOMAL_MAXSIZE = 2 * 1024;

export const wmValidateRule = {
    width: NOMAL_WIDTH,
    height: NOMAL_HEIGHT,
    maxSize: NOMAL_MAXSIZE,
    picFormat: ['jpg', 'jpeg', 'png'],
};
export const lbValidateRule = {
    maxSize: 10 * 1024,
    picFormat: ['jpg', 'jpeg', 'png'],
};
export const dlbValidateRule = {
    width: operatePicInfo.DLB_WIDTH,
    height: operatePicInfo.DLB_HEIGHT,
    maxSize: operatePicInfo.DLB_MAXSIZE,
    picFormat: ['gif'],
};
// 营养图校验
export const nutritionValidateRule = {
    width: NOMAL_WIDTH,
    maxSize: NOMAL_MAXSIZE,
    picFormat: ['jpg', 'jpeg', 'png'],
};
export const skuPictureListRule = {
    width: NOMAL_WIDTH,
    height: NOMAL_HEIGHT,
    maxSize: NOMAL_MAXSIZE,
    pic: {
        picFormat: ['jpg', 'jpeg', 'gif', 'png'],
        picMaxSize: NOMAL_MAXSIZE,
    },
};

export const recSceneValidateRule = {
    width: operatePicInfo.SCENE_WIDTH,
    height: operatePicInfo.SCENE_HEIGHT,
    maxSize: operatePicInfo.SCENE_MAXSIZE,
    picFormat: ['jpg', 'jpeg'],
};

export const primeValidateRule = {
    width: operatePicInfo.DSK_WIDTH,
    height: operatePicInfo.DSK_HEIGHT,
    maxSize: NOMAL_MAXSIZE,
    picFormat: ['jpg', 'jpeg'],
};

export const videodateRule = {
    maxSize: operatePicInfo.VIDEO_MAXSIZE, // 单位M
    format: [
        'mp4',
        'x-ms-wmv',
        'x-msvideo',
        '3gpp',
        'mpeg',
        'x-matroska',
        'avi',
    ], // 格式
};

export const approvalStatusMap = Object.freeze({
    DONE: 1,
    UNFINISHED: 2,
    OUTLINE: -10,
});

export const defaultNutritionsItems = () => ({
    uuId: getUuid(),
    itemName: '',
    parentItem: '',
    details: ['', '', ''],
});

export const defaultNutritions = () => ({
    uuId: getUuid(),
    productName: '',
    nutritions: {
        headers: ['项目', '', ''],
        items: [defaultNutritionsItems()],
    },
});

export const defaultIngredients = () => ({ productName: '', ingredients: [], uuId: getUuid() });

export const defaultForm = () => (
    {
        purchaserMis: '', // 采购mis号
        supplierId: '', // 供货名称id
        supplyName: '', // 供货规则
        skuBaseId: '',
        categoryId: '', // 分类id
        subTitle: '', // 副标题
        recommend: '', // 营销推荐语
        description: '', // 商品详情（后端返回字段）
        topDescription: '', // 商品详情顶部（前端渲染字段）
        mediumDescription: '', // 商品详情中部（前端渲染字段）
        bottomDescription: '', // 商品详情底部（前端渲染字段）
        questions: [], // 常见问题
        lbPicture: null, // 列表用图
        video: null, // 短视频,结构等同于图片，差异于内部的类型PictureType=3
        dlbPicture: null, // 动态列表图
        wmPicture: null,
        wmPictureList: [], // 外卖侧用图
        skuPictureList: [], // 商品主图
        recommendScenePicture: null, // 猜喜场景图
        primeSelectPicture: null, // 大商卡图
        yyPicture: null, // 营养成分/配料表图
        tipsPicture: null, // 商品主图-小贴士
        ztPictureList: [],
        skuExtAttrList: [], // sku扩展属性
        skuSellPointContentList: [], // sku绑定的商品卖点内容列表 商品卖点
        nutritions: [defaultNutritions()],
        ingredients: [defaultIngredients()],
        ingredientsUsedPic: '',
        nutritionsUsedPic: '',
        itemLabelMap: {},
        isAdoptItemLabel: 0,
        buyRecommendationDesc: '',
        buyRecommendationSellPoints: [{ sellPointKeyDesc: '', sellPointContentDesc: '' }],
    }
);

// 新增加的

// 城市经营信息详情 数据结构 和 提报详情 有些许不一致
// 城市经营信息使用
function convertDetail(data = {}) {
    return {
        ...data,
        citySkuAttributes: data.cityExtSkuMappingList,
        shippingType: (data.shippingInfo && data.shippingInfo.shippingType),
        rdcIdList: (data.shippingInfo && data.shippingInfo.rdcIdList),
        thawingRdcIdList: (data.shippingInfo && data.shippingInfo.thawingRdcIdList),
        supplierId: data.shippingType || (data.shippingInfo && data.shippingInfo.supplierId),
    };
}

// null,undefined,'' -1 为需要转化值 （0不需要）
function emptyToDefault(val, def = '') {
    if (val == null || val === '' || +val === -1) return def;
    return val;
}
export class CityInfoModel {
    constructor(data = {}, conver = true) {
        const temp = conver ? convertDetail(data) : data;
        this.skuType = emptyToDefault(temp.skuType, 1); // 加工状态:成品1，原料2，加工品3
        this.cityId = temp.cityId; // 城市ID
        this.fdcGroups = emptyToDefault(temp.fdcGroups, []).map((i) => +i); // 售卖站群id列表
        this.fdcIds = emptyToDefault(temp.fdcIds, []); // 售卖站点id列表
        this.shippingType = emptyToDefault(temp.shippingType); // 配送方式
        this.rdcIdList = emptyToDefault(temp.rdcIdList, []); // 仓
        this.thawingRdcIdList = emptyToDefault(temp.thawingRdcIdList, []); // 解冻仓
        this.supplierId = emptyToDefault(temp.supplierId); // 供应商
        this.rdcMulSupplierInfo = emptyToDefault(temp.rdcMulSupplierInfo, { supplierList: [] }); // 一品多供
        this.manufacturerId = emptyToDefault(temp.manufacturerId); // 生产商id
        this.manufacturerName = emptyToDefault(temp.manufacturerName); // 生产商name
        this.wacPrice = emptyToDefault(temp.wacPrice); // 城市wac成本价
        this.purchasePrice = emptyToDefault(temp.purchasePrice); // 城市采购价
        this.replenishStep = emptyToDefault(temp.replenishStep); // 补货步长
        this.detachFlag = emptyToDefault(temp.detachFlag); // 是否可拆零
        this.skuBaseRelates = emptyToDefault(temp.skuBaseRelates, []); // 补货相关品后端接口参数
        this.skuRelateInfos = []; // 补货相关品内容信息
        this.citySkuAttributes = emptyToDefault(temp.citySkuAttributes, []);
        this.sourceChannels = emptyToDefault(temp.sourceChannels, []); // 销售渠道
        this.addSpan = emptyToDefault(temp.addSpan, 1); // 购买步长
        this.sellUnitId = emptyToDefault(`${temp.sellUnitId}`);
        this.sellUnitName = emptyToDefault(temp.sellUnitName);
        this.sellUnitRelationQuantity = emptyToDefault(temp.sellUnitRelationQuantity);
        this.orderMin = emptyToDefault(temp.orderMin, 1); // 最小购买步长
        this.orderMax = emptyToDefault(temp.orderMax, -1); // 每单限购数
        this.deliveryFloatMore = emptyToDefault(temp.deliveryFloatMore); // 浮动上限
        this.deliveryFloatLess = emptyToDefault(temp.deliveryFloatLess); // 浮动下限
        this.sellPrice = emptyToDefault(temp.sellPrice); // 城市售价
        this.staffId = emptyToDefault(temp.staffId, 0); // 销售部门id, 兼容海屯
        this.citySkuStatus = emptyToDefault(temp.citySkuStatus, 0); // 商品状态 1：新建档，2：上架，3：仅采不售，4：暂时停采，5：下架
        this.categoryType = emptyToDefault(temp.categoryType, 1); // 品类属性 1商品 2物料
        this.sellGpr = emptyToDefault(temp.sellGpr); // 初始毛利率
        this.wacGpr = emptyToDefault(temp.wacGpr); // 成本毛利率
        this.sellPurposeType = emptyToDefault(temp.sellPurposeType, null); // 售卖类型 -1：无售卖类型，0：历史数据的无售卖类型，1：正常售卖品，2：仅赠送不对用户售卖，3：仅地推不对用户售卖，4：仅作成品原料不对用户售卖
        this.seasonalSale = emptyToDefault(temp.seasonalSale, null); // 是否应季品 1：是，0：否
    }

    // 可以处理特殊逻辑
    handleSpecialCase(skuInfo) {
        // 销售单位不存在时，取基础单位代替
        if (!this.sellUnitId) {
            this.sellUnitId = String(skuInfo.unitId);
            this.sellUnitName = skuInfo.unitName;
        }
        this.sellPurposeType = this.sellPurposeType > 0 ? this.sellPurposeType : null; // 售卖类型返回是0(表示没有售卖类型)时，需要将其转化成默认值null
        this.seasonalSale = [0, 1].includes(this.seasonalSale) ? this.seasonalSale : null; // 是否应季品没有返回时(老数据没有是否应季品)时，需要将其转化成默认值
    }

    addData({ key, value }) {
        this[key] = value;
    }

    // eslint-disable-next-line consistent-return
    async syncSkuRelateInfos() {
        if (!this.skuBaseRelates.length) return;

        const skuIdList = this.skuBaseRelates.map((skuRelate) => skuRelate.relateSkuId || skuRelate.skuBaseId);
        // eslint-disable-next-line no-undef
        const response = await Vue.prototype.$service.getNewSkuBaseList({
            paging: {
                offset: 0,
                limit: skuIdList.length,
            },
            paramValueList: [
                {
                    paramName: 'skuIdList',
                    paramValue: skuIdList.join(','),
                },
            ],
        }).catch((err) => {
            this.$message.error(err.message || err.msg || '获取sku基本信息失败');
            return null;
        });
        if (!response) return;

        this.skuRelateInfos = response.items;
    }

    // 提交前恢复给后端的数据格式 （资质信息结构）
    toResult(skuInfo) {
        const {
            cityId, fdcGroups, purchasePrice, replenishStep, detachFlag, citySkuAttributes, sourceChannels,
            addSpan, sellUnitId, sellUnitName, sellUnitRelationQuantity, orderMin, orderMax, deliveryFloatLess,
            deliveryFloatMore, sellPrice, staffId, mulSuppliers, sellPurposeType, seasonalSale,
        } = this;
        return {
            cityId,
            fdcGroups,
            purchasePrice,
            replenishStep,
            detachFlag,
            sourceChannels,
            addSpan,
            sellUnitId,
            sellUnitName,
            sellUnitRelationQuantity,
            orderMin,
            orderMax,
            deliveryFloatLess,
            deliveryFloatMore,
            sellPrice,
            staffId,
            sellPurposeType,
            seasonalSale,
            cityExtSkuMappingList: citySkuAttributes,
            shippingInfo: {
                shippingType: this.shippingType,
                rdcIdList: this.rdcIdList,
                supplierId: this.supplierId,
                thawingRdcIdList: this.thawingRdcIdList,
            },
            skuBaseRelates: this.skuRelateInfos.map((skuRelate) => ({
                skuBaseId: skuInfo.skuBaseId,
                relateSkuId: skuRelate.skuId,
                relateType: 2, // 写死 相似品
                sceneType: 1, // 写死 补货场景
            })),
            rdcMulSupplierInfo: {
                supplierList: mulSuppliers,
            },
        };
    }
}

export const buhuoProductColumns = [
    {
        label: 'skuId',
        prop: 'skuId',
    },
    {
        label: '商品名称',
        prop: 'skuName',
    },
    {
        label: '分类',
        prop: 'category',
    },
    {
        label: '条形码',
        prop: 'masterBarCode',
    },
    {
        label: '关联规格',
        prop: 'specification',
    },
    {
        label: '形态', // 标品？散装？
        prop: 'packageType',
    },
    {
        label: '7日店均销量',
        prop: '',
    },
];

export const shipTypeList = [
    {
        label: '直送到仓，配送到站', value: 20, needRdc: true, needSupplier: true, allowType: [1, 2],
    }, {
        label: '直送到仓，越库到站', value: 50, needRdc: true, needSupplier: true, allowType: [1, 2],
    }, {
        label: '直送到站', value: 10, needRdc: false, needSupplier: true, allowType: [1, 2],
    }, {
        label: '直送到加工仓', value: 70, needRdc: true, needSupplier: true, allowType: [2],
    }, {
        label: '站点领用', value: 30, needRdc: false, needSupplier: false, allowType: [1],
    }, {
        label: '站点自加工', value: 40, needRdc: false, needSupplier: false, allowType: [3],
    }, {
        label: '加工仓自加工，配送到站', value: 60, needRdc: true, needSupplier: false, allowType: [3],
    },
];

export const contentFields = Object.freeze([
    {
        label: 'SKUID',
        prop: 'skuId',
    },
    {
        label: 'SKU名称',
        prop: 'skuName',
    },
    {
        label: '管理类目',
        prop: 'categoryName',
    },
    {
        label: '后台类目',
        prop: 'bgCategoryName',
    },
    {
        label: '品牌',
        prop: 'brandName',
    },
    {
        label: '规格',
        prop: 'specActual',
    },
]);

// 冻化鲜属性 Id
export const FrozenTofreshAttrId = 20297;
// 冻化鲜答案 Id 是：72391
export const FrozenTofreshAnswerId = 72391;
